import AppInputs from './inputs/index';
import Buttons from './buttons/index';

import AppDropdownMenu from './AppDropdownMenu';
import AppVMenu from '@/components/atoms/inputs/AppVMenu.vue';
import AppTextTooltip from './AppTextTooltip';
import AppInfoTooltipIcon from './AppInfoTooltipIcon';
import AppCloseX from './AppCloseX';
import AppFooter from './AppFooter';
import AppAbsoluteMenu from './AppAbsoluteMenu';
import AppIcon from './AppIcon.vue';

export default {
	...AppInputs,
	...Buttons,

	AppDropdownMenu,
	AppVMenu,
	AppTextTooltip,
	AppInfoTooltipIcon,
	AppCloseX,
	AppAbsoluteMenu,
	AppFooter,
	AppIcon,
};
